import React from 'react';
import { Field } from 'react-final-form';
import { FieldSet, Label, LabeledControl, Legend, Paragraph, Radio, spaceMixin, Text } from '@zillow/constellation';
import styled from 'styled-components';
import type { IdentityCheckQuestion } from '@zg-rentals/ts-id-verification-client';

interface KiqQuestionProps {
  question: IdentityCheckQuestion;
  index: number;
}

const StyledFieldSet = styled(FieldSet)`
  :not(:last-child) {
    margin-bottom: ${spaceMixin('md')};
  }
`;

export default function KiqQuestion({ question, index }: KiqQuestionProps) {
  const questionChoices = question?.questionChoices?.map((_, idx) => idx + 1);

  return (
    <>
      <Text fontType="bodyHeading" marginY="sm">
        Question #{index + 1}
      </Text>
      <StyledFieldSet
        legend={
          <Legend>
            <Paragraph marginBottom="sm">{question.questionText}</Paragraph>
          </Legend>
        }
      >
        {question.questionChoices.map((questionChoice, questionChoiceIndex) => (
          <Field
            key={questionChoice}
            // Answers to Experian use 1-based indexing
            value={`${questionChoiceIndex + 1}`}
            type="radio"
            name={`question-${index}`}
            render={({ input }) => (
              <LabeledControl label={<Label>{questionChoice}</Label>} control={<Radio {...input} />} />
            )}
            validate={(choice) => {
              return questionChoices.includes(Number(choice)) ? undefined : 'Invalid answer.';
            }}
          />
        ))}
      </StyledFieldSet>
    </>
  );
}
